import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link } from "react-router-dom" // Added Meta Tag npm Package
import {
  Row,
  Col,
  Container,
  Card,
  CardBody,
  CardTitle,
  Modal,
  Form,
  Label,
  Input,
  UncontrolledTooltip,
  Badge,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import axios from "axios"
import * as url from "helpers/url_helper"
import { HRConfig, TOAST_OPTIONS } from "helpers/backend_helper"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import { Button } from "reactstrap"
import LoadingOverlay from "react-loading-overlay"
LoadingOverlay.propTypes = undefined
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader"

const Users = () => {
  toastr.options = TOAST_OPTIONS

  const [modal_users, setmodal_users] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [usersList, setUsersList] = useState(null)
  const [levels, setLevels] = useState(["Administrator", "System user"])
  const [companies, setCompanies] = useState([
    "MHUg",
    "MIHS",
    "MRCU",
    "MILDMAY Uganda",
  ])
  const [user, setUser] = useState(null)
  const [isloading, setIsloading] = useState(false)

  const [id, setId] = useState("")
  const [staffNo, setStaffNo] = useState("")
  const [firstName, setFirstName] = useState("")
  const [middleName, setMiddleName] = useState("")
  const [lastName, setLastName] = useState("")
  const [title, setTitle] = useState("")
  const [phone, setPhone] = useState("+256")
  const [email, setEmail] = useState("")
  const [gender, setGender] = useState("")
  const [category, setCategory] = useState("")
  const [username, setUsername] = useState("")
  const [company, setCompany] = useState("")
  const [changePass, setChangePass] = useState("")
  const [userStatus, setUserStatus] = useState("")

  const removeBodyCss = () => {
    document.body.classList.add("no_padding")
  }
  const tog_users = () => {
    setmodal_users(!modal_users)
    removeBodyCss()
  }

  const fetchData = () => {
    setIsloading(true)
    axios
      .get(url.STAFF, HRConfig)
      .then(r => {
        setUsersList(r.data)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleOptionChange = event => {
    const selectedValues = Array.from(
      event.target.selectedOptions,
      option => option.value
    )
    setSelectedModules(selectedValues)
  }

  const handleAddUser = () => {
    if (firstName.trim().length < 3) {
      toastr.error("Enter staff name")
    } else if (title.trim().length < 1) {
      toastr.error("Enter staff title")
    } else if (email.trim().length < 4) {
      toastr.error("Enter staff email address")
    } else {
      const obj = JSON.parse(localStorage.getItem("authMildUser"))
      if (isEdit) {
        const data = {
          firstName: firstName,
          middleName: middleName,
          lastName: lastName,
          gender: gender,
          title: title,
          changePass: changePass,
          phone: phone,
          email: email,
          username: username,
          level: category,
          company: company,
          staffNo: staffNo,
          uuId: id,
          uuName: obj.username,
          action: "edit",
        }
        setIsloading(true)
        axios
          .post(url.STAFF, JSON.stringify(data), HRConfig)
          .then(r => {
            if (r.data.status == "0") {
              toastr.error(r.data.message)
            } else {
              toastr.success(r.data.message)
              fetchData()
              tog_users()
              clearData()
            }
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        const data = {
          firstName: firstName,
          middleName: middleName,
          lastName: lastName,
          gender: gender,
          title: title,
          changePass: "Yes",
          phone: phone,
          email: email,
          username: username,
          level: category,
          company: company,
          staffNo: staffNo,
          uuId: id,
          uuName: obj.username,
          action: "add",
        }
        setIsloading(true)
        axios
          .post(url.STAFF, JSON.stringify(data), HRConfig)
          .then(r => {
            if (r.data.status == "0") {
              toastr.error(r.data.message)
            } else {
              toastr.success(r.data.message)
              fetchData()
              tog_users()
              clearData()
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }

  const handleClickEdit = row => {
    tog_users()
    setIsEdit(true)
    setId(row.uuId)
    setFirstName(row.firstName)
    setMiddleName(row.middleName)
    setLastName(row.lastName)
    setGender(row.gender)
    setChangePass(row.mustChangePass)
    setStaffNo(row.no)
    setPhone(row.phone)
    setEmail(row.email)
    setTitle(row.title)
    setCategory(row.userLevel)
    setCompany(row.company)
    setUsername(row.username)
    setUserStatus(row.userStatus)
  }
  const clearData = () => {
    setIsEdit(false)
    setId("")
    setFirstName("")
    setMiddleName("")
    setLastName("")
    setGender("")
    setChangePass("")
    setStaffNo("")
    setPhone("")
    setEmail("")
    setTitle("")
    setCategory("")
    setCompany("")
    setUsername("")
    setUserStatus("")
  }
  const handleClickAdd = () => {
    setIsEdit(false)
    clearData()
    tog_users()
  }

  const { SearchBar } = Search
  const columns = [
    {
      dataField: "uuId",
      text: "Id",
      sort: true,
      // hidden: true,
    },
    {
      dataField: "no",
      text: "No",
      sort: true,
    },
    {
      dataField: "firstName",
      text: "First name",
      sort: true,
    },
    {
      dataField: "lastName",
      text: "Last name",
      sort: true,
    },
    {
      dataField: "title",
      text: "Title",
      sort: true,
    },
    {
      dataField: "username",
      text: "User Name",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "lastLogin",
      text: "Last Login",
      sort: true,
    },
    {
      dataField: "status",
      text: "",
      sort: true,
      formatter: statusFormatter,
    },
    {
      dataField: "company",
      text: "Company",
      sort: true,
    },
    {
      dataField: "",
      isDummyField: true,
      text: "",
      formatter: actionFormatter,
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  function statusFormatter(cellContent, row) {
    if (row.status == "Active") {
      return (
        <div>
          <Badge className="me-2 bg-success">{cellContent}</Badge>
        </div>
      )
    } else {
      return (
        <div>
          <Badge className="me-2 bg-danger">{cellContent}</Badge>
        </div>
      )
    }
  }
  function actionFormatter(cellContent, row) {
    return (
      <>
        <Button
          type="button"
          color="info"
          className="btn-sm btn-rounded"
          onClick={() => {
            handleClickEdit(row)
          }}
        >
          Details
        </Button>
      </>
    )
  }

  return (
    <>
      <LoadingOverlay
        active={isloading}
        spinner={<ClimbingBoxLoader />}
        text="Please wait..."
      >
        <div className="page-content">
          <MetaTags>
            <title>Users | BRIDGE</title>
          </MetaTags>
          <Container fluid={true}>
            <Breadcrumbs title="User Management" breadcrumbItem="Users" />

            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4">&nbsp;</CardTitle>

                    <Modal
                      isOpen={modal_users}
                      toggle={() => {
                        tog_users()
                      }}
                      centered
                    >
                      <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">
                          {isEdit ? "Edit User " : "Add User"}
                        </h5>
                        <button
                          type="button"
                          onClick={() => {
                            setmodal_users(false)
                          }}
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label"
                          >
                            Staff Id
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={id}
                              onChange={e => setId(e.target.value)}
                              disabled={true}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label"
                          >
                            Staff No
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={staffNo}
                              onChange={e => setStaffNo(e.target.value)}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label"
                          >
                            First name
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={firstName}
                              onChange={e => setFirstName(e.target.value)}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label"
                          >
                            Middle name
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={middleName}
                              onChange={e => setMiddleName(e.target.value)}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label"
                          >
                            Last name
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={lastName}
                              onChange={e => setLastName(e.target.value)}
                            />
                          </Col>
                        </div>

                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            Title
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={title}
                              onChange={e => setTitle(e.target.value)}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            Phone
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="phone"
                              className="form-control"
                              value={phone}
                              onChange={e => setPhone(e.target.value)}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            E-mail
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="email"
                              className="form-control"
                              value={email}
                              onChange={e => setEmail(e.target.value)}
                            />
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            Gender
                          </Label>
                          <Col sm={12}>
                            <select
                              className="form-select"
                              value={gender}
                              onChange={e => setGender(e.target.value)}
                            >
                              <option>Select</option>
                              <option value={`Male`}>Male</option>
                              <option value={`Female`}>Female</option>
                            </select>
                          </Col>
                        </div>

                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label"
                          >
                            Username
                          </Label>
                          <Col sm={12}>
                            <Input
                              type="text"
                              className="form-control"
                              value={username}
                              onChange={e => setUsername(e.target.value)}
                            />
                          </Col>
                        </div>

                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            Access level
                          </Label>
                          <Col sm={12}>
                            <select
                              className="form-select"
                              value={category}
                              onChange={e => setCategory(e.target.value)}
                            >
                              <option>Select</option>
                              {levels.map((a, k) => (
                                <option key={k} value={a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            Company
                          </Label>
                          <Col sm={12}>
                            <select
                              className="form-select"
                              value={company}
                              onChange={e => setCompany(e.target.value)}
                            >
                              <option>Select</option>
                              {companies.map((a, k) => (
                                <option key={k} value={a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </Col>
                        </div>
                        <div className="row mb-2">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-12 col-form-label"
                          >
                            Change password on next login
                          </Label>
                          <Col sm={12}>
                            <select
                              className="form-select"
                              value={changePass}
                              onChange={e => setChangePass(e.target.value)}
                            >
                              <option value={`No`}>No</option>
                              <option value={`Yes`}>Yes</option>
                            </select>
                          </Col>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          onClick={() => {
                            tog_users()
                          }}
                          className="btn btn-danger "
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-success "
                          onClick={() => {
                            handleAddUser()
                          }}
                        >
                          Save...
                        </button>
                      </div>
                    </Modal>

                    {usersList && usersList.length > 0 && (
                      <>
                        <ToolkitProvider
                          keyField="no"
                          data={usersList}
                          columns={columns}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="mb-5">
                                <Col lg={8} className="mb-2">
                                  <div className="rounded bg-light d-grid gap-2">
                                    <SearchBar
                                      {...toolkitProps.searchProps}
                                      className="form-control bg-transparent border-0 searchTm m-0"
                                    />
                                  </div>
                                </Col>

                                <Col lg={4}>
                                  <div className="d-grid gap-2">
                                    <Button
                                      color="primary"
                                      className="btn"
                                      onClick={() => {
                                        handleClickAdd()
                                      }}
                                    >
                                      <i className="mdi mdi-plus me-1" />
                                      Add system user
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField="no"
                                      data={usersList}
                                      columns={columns}
                                      striped
                                      //hover
                                      condensed
                                      bordered={false}
                                      noDataIndication="No Records"
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-check"
                                      }
                                      {...toolkitProps.baseProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      </>
                    )}
                    {usersList && usersList.length < 1 && (
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                        </div>
                        <div>
                          <h5>No Users Found</h5>
                          <p className="text-muted"></p>
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </LoadingOverlay>
    </>
  )
}

export default Users
